$('#cart-icon-bubble').click(function(event) {
    event.preventDefault();
    openModalCart();
});


function clearCart(id){
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        console.log('clear:', data);
        addToCart(id);
    });
}
function addToCart(id){
    var data = {
        items: [
            {
                id: id,
                quantity: 1
            }
        ],
        sections: "side-cart",
    };  
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        console.log('Success:', data);
        
        var html = new DOMParser().parseFromString(data.sections['side-cart'], 'text/html');
        document.querySelector('#cart-data').innerHTML = html.querySelector('#cart-data').innerHTML;

        document.querySelector('.product_btm-box .prd__details').innerHTML = html.querySelector('.product_btm-box .prd__details').innerHTML;
        openModalCart();
        if (window.innerWidth < 991) {
            $('.modal-cart-main .modal-cart-left').hide(); 
        }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}
$('#cart-data').on('click', '.cart-addToCart', function(event){
event.preventDefault();
var id = $(this).data('id');
var item_count = $('#cart-item_count').val();
if(item_count == 0){
    addToCart(id);
}else{
    clearCart(id);
}
});
$('.addToCart').click(function(event) {
    event.preventDefault();
    var id = $(this).data('id');
    var item_count = $('#cart-item_count').val();
    if(item_count == 0){
        addToCart(id);
    }else{
        clearCart(id)
    }
});

 
$('.change-item-mob').click(function(event) {
    event.preventDefault();
    $('.modal-cart-main .modal-cart-left').show();
});
const body1 = document.querySelector("body");
const modalCartMain1 = document.querySelector(
  ".modal-cart-block .modal-cart-main"
);
$('.modal-cart-main .close-btn').click(function(event) {
    event.preventDefault();
    if (window.innerWidth < 991) {
        $('.modal-cart-main .modal-cart-left').hide(); 
    }else{
        modalCartMain1.classList.remove("open");
        body1.classList.remove("side-cart-open");
    }
}); 





function addToCartForm(formData){
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(data => {
        console.log('Success:', data);
        
        var html = new DOMParser().parseFromString(data.sections['side-cart'], 'text/html');
        document.querySelector('#cart-data').innerHTML = html.querySelector('#cart-data').innerHTML;

        document.querySelector('.product_btm-box .prd__details').innerHTML = html.querySelector('.product_btm-box .prd__details').innerHTML;
        openModalCart();
        if (window.innerWidth < 991) {
            $('.modal-cart-main .modal-cart-left').hide(); 
        }
    })
    .catch(error => {
        console.error('Error:', error);
    });
}


  $(".calendly-embed").click(function(e) {
    e.preventDefault();
        $(".calendly_init").show();
        $(".cart_init").hide();
    });

  $(".back-btn").click(function(e) {
    e.preventDefault();
        $(".calendly_init").hide();
        $(".cart_init").show();
    });
